import { ErrorResponse, SuccessResponse } from "./response";

export enum AuthState {
  IDLE = "idle",
  AUTHENTICATING = "authenticating",
  AUTHENTICATED = "authenticated",
  UNAUTHENTICATED = "unauthenticated",
  LOGOUT = "logout",
}

export interface LoginInput {
  email: string;
}

export interface VerifyOTPInput {
  email: string;
  otp_code: string;
}

export interface ResendOTPInput {
  email: string;
}

export type AuthResponse = SuccessResponse | ErrorResponse;

export type RegisterResponseData = Response
export type RegisterResponse = SuccessResponse<RegisterResponseData> | ErrorResponse;

export type LoginResponseData = Response

export type LoginResponse = SuccessResponse<LoginResponseData> | ErrorResponse;

export type DeleteResponseData = Response

export type DeleteResponse = SuccessResponse<DeleteResponseData> | ErrorResponse;

export type VerifyOTPResponseData =  Response & {
  user: {
    user_id: string;
    first_name: string;
    last_name: string;
    email: string;
  };
  token: string;
};

export type VerifyOTPResponse = SuccessResponse<VerifyOTPResponseData> | ErrorResponse;

export type ResendOTPResponseData = Response
export type ResendOTPResponse = SuccessResponse<ResendOTPResponseData> | ErrorResponse;
